import { Maybe, Scalars } from '@iss/libs/graphql';
import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@wo-environments';

export type ApplicationInfo = Readonly<{
  app: Maybe<Readonly<{
    version: Scalars['String'];
  }>>;
  git: Maybe<Readonly<{
    commit: Maybe<Readonly<{
      id: Scalars['String'];
      time: Scalars['DateTime'];
    }>>;
    tags: Scalars['String'];
  }>>;
}>;

@Injectable({ providedIn: 'root' })
export class GetBackendInfo {
  private static readonly ENDPOINT = `${ environment.backendHost }/actuator/info`;
  private readonly http = inject(HttpClient);

  public getInfo() {
    return this.http.get<ApplicationInfo>(GetBackendInfo.ENDPOINT);
  }
}
